// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import Notify from 'components/Notify/Notify';
import { useEffect } from 'react';

const App = () => {
    useEffect(() => {
        if (process.env['REACT_APP_ENV'] !== 'local') {
            const script = document.createElement('script');
            script.src = './newrelic.js';
            script.async = true;
            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);

    return (
        <ThemeCustomization>
            <ScrollTop>
                <Notify />
                <Routes />
            </ScrollTop>
        </ThemeCustomization>
    );
};

export default App;
